export const TASK_LABEL_COLORS: readonly string[] = [
  '#4C9195',
  '#4BBF8B',
  '#E6C84D',
  '#F5A623',
  '#E8734A',
  '#CF513D',
  '#CD5A91',
  '#B660CD',
  '#9F8FEF',
  '#5B8FF7',
  '#579DDB',
  '#55A5AD',
  '#4A8F72',
  '#7F8B52',
  '#946F51',
  '#838C98',
];
